/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Exercise_Personal_Goal_BestInputs */

const en_us2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your best so far: ${i?.valueText}`)
};

const pt_br2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu melhor até agora: ${i?.valueText}`)
};

const es_419_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu mejor marca hasta ahora: ${i?.valueText}`)
};

const pt_pt2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O teu melhor até agora: ${i?.valueText}`)
};

const fr_fr2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton meilleur jusqu'ici : ${i?.valueText}`)
};

const de_de2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Bestwert bisher: ${i?.valueText}`)
};

const it_it2_exercise_personal_goal_best = /** @type {(inputs: Exercise_Personal_Goal_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo migliore finora: ${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "Your best so far: {valueText}" |
*
* @param {Exercise_Personal_Goal_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_best = /** @type {((inputs: Exercise_Personal_Goal_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_best(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_best(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_best(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_best(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_best(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_best(inputs)
	return en_us2_exercise_personal_goal_best(inputs)
});
export { exercise_personal_goal_best as "exercise-personal.goal_best" }